<template>
  <div class="ConfirmRegister">
    <div v-if="loading">
      Верификация на акаунта
      <v-icon
        type="refresh"
        class="mps-pulse"
      />
    </div>
  </div>
</template>

<script>
/**
 * @module ConfirmRegister
 */

import { AuthApiService } from '../services/api/AuthApiService'

export default {
  name: 'ConfirmRegister',
  props: {
    confirmKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.confirm()
    })
  },
  methods: {
    async confirm () {
      try {
        this.loading = true
        await AuthApiService.verifyEmail(this.confirmKey)
        this.$notify.success('Ти успешно потвърди своя акаунт.')
        this.$router.replace({ name: 'login', query: { redirect: '/round/3' } })
      } catch (err) {
        this.$displayError(err, [405])
        this.$router.replace({ name: 'home' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
